'use client';

import React, { useState } from 'react';
import styles from './ReferAFriend.module.css';

const ReferAFriend = ({ userReferralCode, userEmail }) => {
  const [recipientEmail, setRecipientEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    if (!recipientEmail) {
      setMessage({ type: 'error', text: 'Please enter an email address.' });
      return;
    }

    if (!/\S+@\S+\.\S+/.test(recipientEmail)) {
      setMessage({ type: 'error', text: 'Please enter a valid email address.' });
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch('/api/referrals/send-invite', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          recipientEmail,
          referralCode: userReferralCode,
          referrerEmail: userEmail,
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage({ type: 'success', text: data.message || 'Referral email sent successfully!' });
        setRecipientEmail('');
      } else {
        setMessage({ type: 'error', text: data.message || 'Failed to send referral email.' });
      }
    } catch (error) {
      console.error('Error sending referral:', error);
      setMessage({ type: 'error', text: 'An unexpected error occurred. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.referFriendContainer}>
      <h3 className={styles.referFriendTitle}>Refer a Friend</h3>
      <p className={styles.referFriendDescription}>
        Know someone who'd be interested in GAM Tokens? Share your referral code with them!
      </p>
      <form onSubmit={handleSubmit} className={styles.referForm}>
        <input
          type="email"
          value={recipientEmail}
          onChange={(e) => setRecipientEmail(e.target.value)}
          placeholder="Enter friend's email address"
          className={styles.referInput}
          disabled={isLoading}
        />
        <button type="submit" className={styles.referButton} disabled={isLoading}>
          {isLoading ? 'Sending...' : 'Send Referral'}
        </button>
      </form>
      {message.text && (
        <p className={`${styles.message} ${message.type === 'success' ? styles.successMessage : styles.errorMessage}`}>
          {message.text}
        </p>
      )}
    </div>
  );
};

export default ReferAFriend; 